export default __webpack_public_path__ + "static/18947-f2a509c046f1a2622d9b90b27ada9fdf.jpg";